import type { DrillProgress } from "../handwriting/xiezi-stages.js";
import { showCues } from "./lianxi-cues.js";
import { showPlaces } from "./lianxi-places.js";
import { joined } from "./lianxi-finish-copy.js";
import { exerciseLine } from "./xiezi-copy.js";
import { type DrillParts, showFinished } from "./xiezi-view.js";

/**
 * Putting where the round has got to onto the page.
 *
 * The row over the square says where each character is and which is in the
 * square, the cue under the line says what the character in the square is,
 * and once every character is finished the line over the square says
 * so, and that the material is in 复习 where the keeper has heard it is.
 * `lianxi-xiezi.ts` calls it after every move between characters, the way
 * `xiezi-view.ts` is called after every move within one.
 * @param parts - The block's pieces.
 * @param items - The row's items, one per character.
 * @param progress - Where the reader is with each character.
 * @param current - Which character is in the square, or nothing once finished.
 * @param after - What the finish says after its own line, which is the
 * hand-over once the material is in 复习 (`lianxi-finish-copy.ts`).
 */
export function showRound(
  parts: Pick<DrillParts, "stage">,
  items: readonly HTMLElement[],
  progress: readonly DrillProgress[],
  current: number | undefined,
  after = "",
): void {
  if (current === undefined) {
    showFinished(parts.stage, joined(exerciseLine(progress.length), after));
  }

  showPlaces(items, progress, current);
  showCues(items, progress, current);
}
